<script setup>
/**
 * LandingCTA V3 - Gradient Call to Action
 *
 * Migrated from public/prototypes/landing-v3-storytelling.html
 * Full-width CTA section with gradient background and decorative blobs
 */

const scrollToSection = (href) => {
  const element = document.querySelector(href)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<template>
  <section class="py-24 bg-gradient-to-br from-accent-600 via-accent-500 to-accent-600 relative overflow-hidden">
    <!-- Background decoration -->
    <div class="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
    <div class="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>

    <div class="max-w-4xl mx-auto px-6 text-center relative z-10">
      <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
        ¿Listo para proteger tu privacidad?
      </h2>
      <p class="text-xl text-accent-100 mb-10 max-w-2xl mx-auto">
        Ejercicio profesional del derecho al olvido. Sin promesas vacias, solo procesos legales reales.
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="#precios"
          class="inline-flex items-center justify-center px-10 py-4 bg-white text-accent-700 font-semibold rounded-2xl hover:bg-accent-50 transition-all text-lg shadow-lg cursor-pointer"
          @click.prevent="scrollToSection('#precios')"
        >
          Ver planes y precios
        </a>
        <a
          href="#servicios"
          class="inline-flex items-center justify-center px-10 py-4 border-2 border-white/30 text-white font-semibold rounded-2xl hover:bg-white/10 transition-all text-lg cursor-pointer"
          @click.prevent="scrollToSection('#servicios')"
        >
          Explorar servicios
        </a>
      </div>
    </div>
  </section>
</template>
